import * as React from "react";
import { BarChart, Button, Box } from "@amzn/awsui-components-react/polaris";
import { RecommendationItem } from "../../calcBusterTypes";
import { getSavingsArray } from "../../util";

const SavingsBarChart: React.FC<{ recommendations: RecommendationItem[] }> = ({
  recommendations,
}) => {
  const savingArray = getSavingsArray(recommendations);

  return (
    <BarChart
      series={[
        {
          title: "ARR",
          type: "bar",
          data: savingArray.map((item) => ({
            x: item.name,
            y: item.value,
          })),
          valueFormatter: (e) => "$" + e.toLocaleString("en-US"),
        },
      ]}
      ariaLabel="Bar chart of ARR savings by service type"
      height={200}
      hideFilter
      hideLegend
      xTitle="Service Code"
      yTitle="Savings by Service"
      empty={
        <Box textAlign="center" color="inherit">
          <b>No data available</b>
          <Box variant="p" color="inherit">
            There is no data available
          </Box>
        </Box>
      }
      noMatch={
        <Box textAlign="center" color="inherit">
          <b>No matching data</b>
          <Box variant="p" color="inherit">
            There is no matching data to display
          </Box>
          <Button>Clear filter</Button>
        </Box>
      }
    />
  );
};

export default SavingsBarChart;
